
import { Grid, Tabs, Tab } from "@mui/material";
import React from "react";
import { MDBox } from "../../../Component/Common/Components/MDBox";
import { MDTypography } from "../../../Component/Common/Components/MDTypography";
import { WorkforceProfile } from "./WorkforceProfile/WorkforceProfile";
import { SkillsDevelopment } from "./SkillsDevelopment/SkillsDevelopment";
import { MonitoringAndEvaluation } from "./MonitoringAndEvaluation/MonitoringAndEvaluation";
import { useRecoilValue } from "recoil";
import { ScorecardAtom } from "../../../State/Scorecard.Atom";
import { Movements } from "./Movements/Movements";
import { Link, Route, Switch } from "react-router-dom";
import { useRouteMatch } from "../../../Helpers/RouteMatcher";

export const EEA2Base = () => {
    const scorecard = useRecoilValue(ScorecardAtom);

    const routes = [
        "/ee/scorecard/" + scorecard.scorecardId + "/workforceProfile/WorkforceProfile",
        "/ee/scorecard/" + scorecard.scorecardId + "/workforceProfile/Movements",
        "/ee/scorecard/" + scorecard.scorecardId + "/workforceProfile/SkillsDevelopment",
        "/ee/scorecard/" + scorecard.scorecardId + "/workforceProfile/MonitoringAndEvaluation"
    ]

    const routeMatch = useRouteMatch(routes);
    const currentTab = routeMatch?.path;

    return (

        <>
            <MDBox style={{ padding: "10px" }}>
                <MDTypography variant='h4' fontWeight='bold' style={{ paddingBottom: "15px" }}>
                    Workforce Profile (EEA2)
                </MDTypography>
            </MDBox>

            <Grid container>
                <Grid item xs={12}>
                    <Tabs value={currentTab} aria-label="Tabs" centered>
                        <Tab label="Workforce Profile" value={routes[0]} to={routes[0]} component={Link} />
                        <Tab label="Movements" value={routes[1]} to={routes[1]} component={Link} />
                        <Tab label="Skills Development" value={routes[2]} to={routes[2]} component={Link} />
                        <Tab label="Monitoring & Evaluation" value={routes[3]} to={routes[3]} component={Link} />
                    </Tabs>
                </Grid>
                <Grid item xs={12} mt={2}>
                    <Switch>
                        <Route path={routes[0]}>
                            <WorkforceProfile scorecardId={scorecard.scorecardId} />
                        </Route>
                        <Route path={routes[1]}>
                            <Movements scorecardId={scorecard.scorecardId} />
                        </Route>
                        <Route path={routes[2]}>
                            <SkillsDevelopment scorecardId={scorecard.scorecardId} />
                        </Route>
                        <Route path={routes[3]}>
                            <MonitoringAndEvaluation scorecardId={scorecard.scorecardId} />
                        </Route>
                    </Switch>
                </Grid>
            </Grid>
        </>);
}